function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var UIModTemplate = require('./../../../templates/uimodtemplate');
var SaitoHeaderTemplate = require('./saito-header.template');
var FloatingMenu = require('./saito-floating-menu.template');
var SaitoOverlay = require('./../saito-overlay/saito-overlay');
var SaitoLoader = require('./../saito-loader/saito-loader');
var UserMenu = require('./../modals/user-menu/user-menu');
var SaitoBackup = require('./../modals/saito-backup/saito-backup');
var SelectNFT = require('./../saito-nft/overlays/select-nft-overlay');

//
// UIModTemplate
//
// The header derives from UIModTemplate -- this allows the component
// to be added to the list of modules that are actively running on Saito
// thus allowing them to receive transactions and update their UI just
// like any other modules.
//

//
// Note: inherits this.publicKey from modtemplate
//
var SaitoHeader = /*#__PURE__*/function (_UIModTemplate) {
  function SaitoHeader(app, mod) {
    var _this;
    _classCallCheck(this, SaitoHeader);
    _this = _callSuper(this, SaitoHeader, [app]);

    //
    // UI components as modules allows them to respond
    // to events individually...
    //
    _this.name = 'SaitoHeader UIComponent';
    _this.slug = 'SaitoHeader';
    _this.app = app;
    _this.mod = mod;

    // employ non-standard css to spacing in header
    _this.header_class = ''; // e.g. game, wide-screen, arcade

    // Header collects notifications to display a count on the hamburger icon
    _this.notifications = {};

    // navigation for clicking on Saito logo in header
    _this.header_location = '/' + mod.returnSlug();

    // Store the mod functions for when you click icon in the menu, e.g. "RedSquare"
    _this.callbacks = {};
    _this.balance_check_interval = null;
    _this.deposit_check_interval = null;
    _this.can_update_header_msg = true;
    _this.show_msg = true;
    _this.loader = new SaitoLoader(_this.app, _this.mod, '#qrcode');
    _this.saito_backup = new SaitoBackup(app, mod);

    // listens for events
    _this.select_nft_overlay = new SelectNFT(app, mod);
    console.log('Create Saito Header for ' + mod.name);
    return _this;
  }
  _inherits(SaitoHeader, _UIModTemplate);
  return _createClass(SaitoHeader, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
        var _this2 = this;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _superPropGet(SaitoHeader, "initialize", this, 3)([app]);
            case 1:
              // here because we need publicKey defined
              this.userMenu = new UserMenu(app, this.publicKey);
              app.connection.on('registry-update-identifier', function (publicKey) {
                if (publicKey === _this2.publicKey) {
                  _this2.renderUsername();
                }
              });
              app.connection.on('saito-header-update-message', function () {
                var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var msg = '';
                _this2.can_update_header_msg = true;
                if ('msg' in obj) {
                  msg = obj.msg;
                  _this2.can_update_header_msg = false;
                }
                var flash = false;
                var callback = null;
                var timeout = null;
                if (obj) {
                  console.log('update header obj: ', obj);
                  _this2.can_update_header_msg = true;
                  if ('msg' in obj) {
                    msg = obj.msg;
                    _this2.can_update_header_msg = false;
                  }
                  if ('flash' in obj) {
                    flash = obj.flash;
                  }
                  if ('callback' in obj) {
                    callback = obj.callback;
                  }
                  if ('timeout' in obj) {
                    timeout = obj.timeout;
                  }
                }
                _this2.updateHeaderMessage(msg, flash, callback, timeout);
              });
              app.connection.on('block-fetch-status', function (count) {
                // trigger block sync ui here
              });
              app.connection.on('saito-header-update-crypto', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      if (!_this2.installing_crypto) {
                        _this2.renderCrypto();
                      } else {
                        console.log('dont render crypto');
                      }
                    case 1:
                      return _context.a(2);
                  }
                }, _callee);
              })));
              app.connection.on('saito-header-install-crypto', function (ticker) {
                console.log('install crypto');
                _this2.installing_crypto = ticker;
                try {
                  document.querySelector('#qrcode').innerHTML = '';
                  document.querySelector('.balance-amount').innerHTML = '';
                  var addressContainer = document.querySelector('#profile-public-key');
                  if (addressContainer) {
                    addressContainer.dataset.add = '';
                    addressContainer.innerHTML = '<div>generating keys...</div>';
                    addressContainer.classList.add('generate-keys');
                  }
                  _this2.loader.show();
                  siteMessage("Installing ".concat(ticker, " in Saito Multiwallet..."), 2000);
                } catch (err) {
                  console.error(err);
                }
              });
              app.connection.on('saito-crypto-activated', function (ticker) {
                if (_this2.installing_crypto && _this2.installing_crypto == ticker) {
                  setTimeout(function () {
                    _this2.installing_crypto = false;
                    _this2.app.connection.emit('saito-backup-render-request', {
                      msg: "Your wallet has added new crypto keys for ".concat(ticker, ". Unless you backup your wallet, you may lose any deposits with those keys.")
                    });
                  }, 1500);
                }
                console.log('$$$$ saito-crypto-activated --> renderCrypto');
                _this2.renderCrypto(true);
              });

              //
              // This allows us to replace the saito logo with a back arrow and a click event
              // In the future, we may want to parameterize what we replace the logo with
              //
              app.connection.on('saito-header-replace-logo', function () {
                var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                if (!document.querySelector('.saito-back-button')) {
                  _this2.app.browser.addElementToSelector("<i class=\"saito-back-button fa-solid fa-arrow-left\"></i>", '.saito-header-logo-wrapper');
                  document.querySelector('.saito-header-logo-wrapper').onclick = function (e) {
                    if (callback) {
                      callback(e);
                    }
                  };
                }
              });
              app.connection.on('saito-header-change-location', function (new_path) {
                _this2.header_location = new_path;
              });
              app.connection.on('saito-header-render', function () {
                _this2.render();
              });
              app.connection.on('saito-header-reset-logo', function () {
                _this2.resetHeaderLogo();
              });
              app.connection.on('saito-header-notification', function (source_mod, unread) {
                _this2.notifications[source_mod] = unread;
                var total = 0;
                for (var m in _this2.notifications) {
                  total += _this2.notifications[m];
                }
                _this2.app.browser.addNotificationToId(total, 'saito-header-menu-toggle');
              });
              this.app.connection.on('saito-header-logo-change-request', function (obj) {
                _this2.resetHeaderLogo();
              });
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "resetHeaderLogo",
    value: function resetHeaderLogo() {
      var _this3 = this;
      var logo = document.querySelector('.saito-header-logo-wrapper');
      if (logo) {
        logo.innerHTML = this.app.browser.logoSVG();
        logo.onclick = function (e) {
          navigateWindow(_this3.header_location, 300);
        };
      }
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this$mod;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(this.mod == null || !document)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              //
              // add basic framework to DOM if needed
              //
              if (!document.getElementById('saito-header')) {
                this.app.browser.prependElementToDom(SaitoHeaderTemplate(this.app, this.mod, this.header_class));
              } else {
                this.app.browser.replaceElementById(SaitoHeaderTemplate(this.app, this.mod, this.header_class), 'saito-header');
              }

              //
              // Header Logo
              //
              this.resetHeaderLogo();

              //
              // Add a short cut
              //
              if ((_this$mod = this.mod) !== null && _this$mod !== void 0 && _this$mod.use_floating_plus) {
                if (!document.getElementById('saito-floating-menu')) {
                  this.app.browser.addElementToDom(FloatingMenu());
                  this.addFloatingMenu();
                }
              }

              //
              // Process the respondTos for apps that install in the Hamburger menu
              //
              this.addHamburgerMenu();

              //
              // render QR code and cryptos
              //
              //console.log("$$$$ header.Render --> renderCrypto");
              this.renderCrypto(true);

              //
              // Nothing happens here
              //
              _context3.n = 2;
              return this.app.modules.renderInto('.saito-header');
            case 2:
              //
              // Insert user's name
              //
              this.renderUsername();
              this.attachEvents();
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
    /*******************************************
     *
     * Process and add floating plus menu items
     *
     ********************************************/
  }, {
    key: "addFloatingMenu",
    value: function addFloatingMenu() {
      var this_header = this;
      var index = 0;
      var menu_entries = [];

      //
      // collect menu items from respondTos
      //
      var mods = this.app.modules.respondTo('saito-floating-menu');
      var _iterator = _createForOfIteratorHelper(mods),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mod = _step.value;
          var item = mod.respondTo('saito-floating-menu');
          if (item instanceof Array) {
            item.forEach(function (j) {
              if (!j.rank) {
                j.rank = 100;
              }
              menu_entries.push(j);
            });
          }
        }

        // Sort menu items
        //
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var menu_sort = function menu_sort(a, b) {
        if (a.rank < b.rank) {
          return 1;
        }
        if (a.rank > b.rank) {
          return -1;
        }
        return 0;
      };
      menu_entries = menu_entries.sort(menu_sort);

      // Check filters and add HTML
      //
      for (var i = 0; i < menu_entries.length; i++) {
        var j = menu_entries[i];
        var show_me = true;
        var active_mod = this.app.modules.returnActiveModule();
        if (typeof j.disallowed_mods != 'undefined') {
          if (j.disallowed_mods.includes(active_mod.slug)) {
            show_me = false;
          }
        }
        if (typeof j.allowed_mods != 'undefined') {
          show_me = false;
          if (j.allowed_mods.includes(active_mod.slug)) {
            show_me = true;
          }
        }
        if (show_me) {
          var id = "saito_floating_menu_item_".concat(index);
          this_header.callbacks[index] = j.callback;
          this_header.addFloatingMenuItem(j, id, index);
          index++;
        }
      }
    }
  }, {
    key: "addFloatingMenuItem",
    value: function addFloatingMenuItem(item, id, index) {
      var html = "\n          <div id=\"".concat(id, "\" data-id=\"").concat(index, "\" class=\"saito-floating-menu-item\">\n            <i class=\"").concat(item.icon, "\"></i>\n          </div>\n        ");
      if (item !== null && item !== void 0 && item.is_active) {
        this.app.browser.addElementToSelector(html, '.saito-floating-item-container.main');
      } else {
        this.app.browser.addElementToSelector(html, '.saito-floating-item-container.alt');
      }
    }

    /*******************************************
     *
     * Process and add floating main menu items
     *
     ********************************************/
  }, {
    key: "addHamburgerMenu",
    value: function addHamburgerMenu() {
      var mods = this.app.modules.respondTo('saito-header');
      var index = 0;
      var menu_entries = [];
      var _iterator2 = _createForOfIteratorHelper(mods),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var mod1 = _step2.value;
          var item = mod1.respondTo('saito-header');
          if (item instanceof Array) {
            item.forEach(function (j) {
              if (!j.rank) {
                j.rank = 100;
              }
              menu_entries.push(j);
            });
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var menu_sort = function menu_sort(a, b) {
        if (a.rank < b.rank) {
          return -1;
        }
        if (a.rank > b.rank) {
          return 1;
        }
        return 0;
      };
      menu_entries = menu_entries.sort(menu_sort);
      for (var i = 0; i < menu_entries.length; i++) {
        var j = menu_entries[i];
        var show_me = true;
        var active_mod = this.app.modules.returnActiveModule();
        if (typeof j.disallowed_mods != 'undefined') {
          if (j.disallowed_mods.includes(active_mod.slug)) {
            show_me = false;
          }
        }
        if (typeof j.allowed_mods != 'undefined') {
          show_me = false;
          if (j.allowed_mods.includes(active_mod.slug)) {
            show_me = true;
          }
        }
        if (show_me) {
          var id = "saito_header_menu_item_".concat(index);
          this.callbacks[id] = j.callback;
          this.addMenuItem(j, id);
          index++;
          if (j.event) {
            j.event(id);
          }
        }
      }
      Array.from(document.querySelectorAll('.saito-header-appspace-option.quicklaunch')).forEach(function (elem) {
        if (elem.dataset.navigation) {
          elem.oncontextmenu = function (e) {
            e.preventDefault();
            navigateWindow(elem.dataset.navigation);
          };
        }
      });
    }
  }, {
    key: "addMenuItem",
    value: function addMenuItem(item, id) {
      var html = "     \n      <li id=\"".concat(id, "\" data-id=\"").concat(item.text, "\" class=\"saito-header-appspace-option ").concat(item.type, "\" ").concat(item !== null && item !== void 0 && item.navigation ? "data-navigation=\"".concat(item.navigation, "\"") : '', ">\n        <i class=\"").concat(item.icon, "\"></i>\n        <span>").concat(item.text, "</span></li>");
      var keyword = item.type;
      if (!keyword) {
        console.warn('Unclassified responder to saito-header!');
        keyword = 'module';
      }
      if (item.type == 'navigation' || item.type == 'quicklaunch') {
        keyword = 'module';
      }
      var menu = document.querySelector(".saito-header-menu-section .".concat(keyword, "-menu > ul"));
      if (menu) {
        menu.innerHTML += html;
        menu.parentElement.classList.remove('empty-menu-section');
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this4 = this;
      var app = this.app;
      var mod = this.mod;
      var this_header = this;

      //
      // Open/close sidebar
      //

      if (document.querySelector('#saito-header-menu-toggle')) {
        document.querySelector('#saito-header-menu-toggle').addEventListener('click', function () {
          document.querySelector('.saito-header-hamburger-contents').classList.remove('show-wallet');
          _this4.toggleMenu();
        });
      }
      if (document.querySelector('.saito-header-backdrop')) {
        document.querySelector('.saito-header-backdrop').onclick = function () {
          document.querySelector('.saito-header-hamburger-contents').classList.remove('show-wallet');
          _this4.toggleMenu();
        };
      }

      //
      // default buttons
      //
      if (document.getElementById('wallet-btn-withdraw')) {
        document.getElementById('wallet-btn-withdraw').onclick = function (e) {
          document.querySelector('.saito-header-hamburger-contents').classList.remove('show-wallet');
          app.connection.emit('saito-crypto-withdraw-render-request');
          _this4.hideMenu();
        };
      }
      if (document.getElementById('wallet-btn-history')) {
        document.getElementById('wallet-btn-history').onclick = function (e) {
          app.connection.emit('saito-crypto-history-render-request');
          _this4.hideMenu();
        };
      }
      if (document.getElementById('wallet-btn-settings')) {
        document.getElementById('wallet-btn-settings').onclick = function (e) {
          document.querySelector('.saito-header-hamburger-contents').classList.remove('show-wallet');
          app.connection.emit('settings-overlay-render-request');
          _this4.hideMenu();
        };
      }
      if (document.getElementById('wallet-btn-details')) {
        document.getElementById('wallet-btn-details').onclick = function (e) {
          document.querySelector('.saito-header-hamburger-contents').classList.toggle('show-wallet');
          Array.from(e.currentTarget.children).forEach(function (c) {
            c.classList.toggle('hideme');
          });
        };
      }
      if (document.getElementById('wallet-btn-nft')) {
        document.getElementById('wallet-btn-nft').onclick = function (e) {
          document.querySelector('.saito-header-hamburger-contents').classList.remove('show-wallet');
          _this4.app.connection.emit('saito-nft-list-render-request');
        };
      }
      if (document.querySelector('.pubkey-mobile-wrapper')) {
        document.querySelector('.pubkey-mobile-wrapper').onclick = function (e) {
          document.querySelector('.saito-header-hamburger-contents').classList.toggle('show-qr');
        };
      }
      document.querySelector('.pubkey-containter').onclick = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
          var public_key, icon_element;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                public_key = document.getElementById('profile-public-key').dataset.add;
                _context4.n = 1;
                return navigator.clipboard.writeText(public_key);
              case 1:
                icon_element = document.querySelector('.pubkey-containter i.fa-copy');
                icon_element.classList.toggle('fa-copy');
                icon_element.classList.toggle('fa-check');
                setTimeout(function () {
                  icon_element.classList.toggle('fa-copy');
                  icon_element.classList.toggle('fa-check');
                }, 800);
              case 2:
                return _context4.a(2);
            }
          }, _callee4);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }();

      //
      // Change preferred (displayed) crypto currency
      //
      if (document.getElementById('wallet-select-crypto')) {
        document.getElementById('wallet-select-crypto').onchange = /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(e) {
            return _regenerator().w(function (_context5) {
              while (1) switch (_context5.n) {
                case 0:
                  _this4.clearBalanceCheck();
                  _this4.clearPendingDepositsCheck();
                  if (!_this4.app.options.crypto[e.target.value] || !_this4.app.options.crypto[e.target.value].address) {
                    _this4.app.connection.emit('saito-header-install-crypto', e.target.value);
                  }
                  _context5.n = 1;
                  return app.wallet.setPreferredCrypto(e.target.value);
                case 1:
                  console.log('Change preferred crypto, restart polls on crypto balance and pending deposits');
                  _this4.initiateBalanceCheck();
                  _this4.initiatePendingDepositsCheck();
                case 2:
                  return _context5.a(2);
              }
            }, _callee5);
          }));
          return function (_x3) {
            return _ref3.apply(this, arguments);
          };
        }();
      }

      //
      // Apps
      //
      document.querySelectorAll('.saito-header-appspace-option').forEach(function (menu) {
        var id = menu.getAttribute('id');
        var data_id = menu.getAttribute('data-id');
        var callback = this_header.callbacks[id];
        menu.addEventListener('click', /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(e) {
            return _regenerator().w(function (_context6) {
              while (1) switch (_context6.n) {
                case 0:
                  _this4.toggleMenu();
                  e.preventDefault();
                  callback(app, data_id);
                case 1:
                  return _context6.a(2);
              }
            }, _callee6);
          }));
          return function (_x4) {
            return _ref4.apply(this, arguments);
          };
        }());
      });

      //
      // Mobile support
      //

      if (document.querySelector('#saito-floating-plus-btn')) {
        document.getElementById('saito-floating-plus-btn').onclick = function (e) {
          document.getElementById('saito-floating-menu').classList.toggle('activated');
        };
      }
      if (document.getElementById('saito-floating-menu-mask')) {
        document.getElementById('saito-floating-menu-mask').onclick = function (e) {
          var mask = e.currentTarget;
          document.getElementById('saito-floating-menu').classList.toggle('activated');
        };
      }
      document.querySelectorAll('.saito-floating-menu-item').forEach(function (menu) {
        var id = menu.getAttribute('id');
        var data_id = menu.getAttribute('data-id');
        var callback = this_header.callbacks[data_id];
        menu.onclick = function (e) {
          e.preventDefault();
          callback(this_header.app, data_id);
          console.log('hi!');
          document.getElementById('saito-floating-menu').classList.toggle('activated');
        };
      });
    }
  }, {
    key: "toggleMenu",
    value: function toggleMenu() {
      if (document.querySelector('.saito-header-hamburger-contents').classList.contains('show-menu')) {
        this.hideMenu();
      } else {
        this.openMenu();
      }
    }
  }, {
    key: "openMenu",
    value: function openMenu() {
      if (!document.querySelector('.saito-header-hamburger-contents').classList.contains('show-menu')) {
        document.querySelector('.saito-header-hamburger-contents').classList.add('show-menu');
        document.querySelector('.saito-header-backdrop').classList.add('menu-visible');
        console.log('Menu open, start polls on crypto balance and pending deposits');
        this.initiateBalanceCheck();
        this.initiatePendingDepositsCheck();
      }
    }
  }, {
    key: "hideMenu",
    value: function hideMenu() {
      if (document.querySelector('.saito-header-hamburger-contents').classList.contains('show-menu')) {
        document.querySelector('.saito-header-hamburger-contents').classList.remove('show-menu');
        document.querySelector('.saito-header-backdrop').classList.remove('menu-visible');
      }
      this.clearBalanceCheck();
      this.clearPendingDepositsCheck();
    }

    /****************************************************
     *
     * A pair of functions to update the user name field in the header
     * and attach click functionality.
     *
     ***************************************************/
  }, {
    key: "updateHeaderMessage",
    value: function updateHeaderMessage() {
      var _this5 = this;
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var flash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var this_self = this;
      var el = document.getElementById('header-msg');
      if (text == '') {
        this.renderUsername();
      } else {
        el.innerHTML = text;
      }
      if (flash) {
        el.classList.add('flash');
      } else {
        el.classList.remove('flash');
      }
      if (callback != null) {
        if (timeout) {
          console.log('timeout: //////////', timeout);
          setTimeout(function () {
            console.log('Clear flashing reminder from saito-header/updateHeaderMessage');
            this_self.updateHeaderMessage();
          }, timeout);
        }

        //
        // Always click once to clear...
        //
        el.onclick = function () {
          delete _this5.app.options.wallet.backup_required;
          _this5.updateHeaderMessage();
          callback();
        };
      }
    }
  }, {
    key: "renderUsername",
    value: function renderUsername() {
      var _this$app$options$wal,
        _this$app$options$wal2,
        _this6 = this;
      var header_self = this;
      var key = this.app.keychain.returnKey(this.publicKey);
      var username = key !== null && key !== void 0 && key.identifier ? key.identifier : this.app.keychain.returnIdentifierByPublicKey(this.publicKey, true);
      if (username == '' || username == this.publicKey) {
        if (this.app.browser.isMobileBrowser()) {
          username = 'Anonymous';
        } else {
          username = 'Anonymous Account';
        }
        if (key !== null && key !== void 0 && key.has_registered_username) {
          username = 'registering...';
        }
      }
      var el = document.getElementById('header-msg');
      if (!el) {
        return;
      }

      //Update name
      el.innerHTML = sanitize(username);
      el.classList.remove('flash');

      //Differential behavior
      if (username === 'Anonymous Account' || username === 'Anonymous') {
        el.onclick = function (e) {
          header_self.app.connection.emit('register-username-or-login', {
            // this gets saved to be called *not* when we submit the name, but when we receive
            // the onchain confirmation
            success_callback: function success_callback(desired_identifier) {
              header_self.app.connection.emit('saito-backup-render-request', {
                msg: "'".concat(desired_identifier, "' succesfully registered, back up now to protect your account")
              });
            }
          });
        };
      } else if (username == 'registering...') {
        el.onclick = null;
      } else {
        if (key !== null && key !== void 0 && key.email) {
          //Launch profile
          el.onclick = function (e) {
            header_self.userMenu.render();
          };
        } else {
          //Prompt email registration
          el.onclick = function (e) {
            header_self.app.connection.emit('recovery-backup-overlay-render-request');
          };
        }
      }
      console.log('Saito-header renderUsername backup_required? ', (_this$app$options$wal = this.app.options.wallet) === null || _this$app$options$wal === void 0 ? void 0 : _this$app$options$wal.backup_required);
      if ((_this$app$options$wal2 = this.app.options.wallet) !== null && _this$app$options$wal2 !== void 0 && _this$app$options$wal2.backup_required) {
        // Display the (updated) user name for a few seconds before restoring the flashing warning
        setTimeout(function () {
          var _this6$app$options$wa;
          // Make sure still neeeded!
          if ((_this6$app$options$wa = _this6.app.options.wallet) !== null && _this6$app$options$wa !== void 0 && _this6$app$options$wa.backup_required) {
            // Backwards compatibility
            if (_this6.app.options.wallet.backup_required == 1) {
              _this6.app.options.wallet.backup_required = "Have you backed up your wallet recently? Keep your keys and account safe by backing up";
            }
            console.log('Restore flashing reminder from saito-header');
            _this6.updateHeaderMessage('wallet backup required', true, function () {
              _this6.app.connection.emit('saito-backup-render-request', {
                msg: _this6.app.options.wallet.backup_required,
                title: 'BACKUP YOUR WALLET'
              });
            });
          }
        }, 4500);
      }
    }

    /********************************************************
     * ******************************************************
     *
     * Integrate Saito MultiWallet
     *
     * *******************************************************
     * *******************************************************/
  }, {
    key: "renderCrypto",
    value: function renderCrypto() {
      var _this7 = this;
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var available_cryptos = this.app.wallet.returnInstalledCryptos();
      var preferred_crypto = this.app.wallet.returnPreferredCrypto();
      var add = preferred_crypto.returnAddress();
      var addressContainer = document.querySelector('#profile-public-key');
      try {
        if (add && addressContainer) {
          var _addressContainer$dat;
          if (((_addressContainer$dat = addressContainer.dataset) === null || _addressContainer$dat === void 0 ? void 0 : _addressContainer$dat.add) != add || force) {
            //console.log("$$$$ Rendering crypto in Saito Header");
            if (addressContainer.classList.contains('generate-keys')) {
              addressContainer.classList.remove('generate-keys');
            }

            //Set address
            addressContainer.dataset.add = add;
            addressContainer.innerHTML = "".concat(add.slice(0, 8), "...").concat(add.slice(-8));

            // There is an annoying flicker when a new qr code is added because canvas resizing / img generation
            document.querySelector('#qrcode').style.visibility = 'hidden';
            document.querySelector('#qrcode').style.opacity = '0';
            document.querySelector('#qrcode').innerHTML = '';
            this.app.browser.generateQRCode(add, 'qrcode');
            setTimeout(function () {
              document.querySelector('#qrcode').removeAttribute('style');
            }, 100);
          }
        } else {
          console.log('$$$ header or crypto not rendered yet', preferred_crypto, add, addressContainer);
        }
        document.querySelector('.wallet-select-crypto').innerHTML = '';

        //
        // add crypto options
        //
        var options_html = '';
        var menu_html = '';
        //let ercMod = null;

        //try {
        //  ercMod = this.app.wallet.returnCryptoModuleByTicker('ERC-SAITO');
        //} catch (err) {}

        for (var i = 0; i < available_cryptos.length; i++) {
          var crypto_mod = available_cryptos[i];

          // We allow Mixin to collectively handle some stuff for us...
          var rtn_val = crypto_mod.returnLogos();
          options_html = "<option ".concat(crypto_mod.name == preferred_crypto.name ? 'selected' : "", " \n        id=\"crypto-option-").concat(crypto_mod.name, "\" value=\"").concat(crypto_mod.ticker, "\">").concat(crypto_mod.ticker, "</option>");
          menu_html += "<div class=\"saito-crypto-details ".concat(crypto_mod.isActivated() ? 'active' : 'unactive', "\" data-ticker=\"").concat(crypto_mod.ticker, "\">");
          menu_html += "<div class=\"crypto-logo-container\"><img class=\"crypto-logo\" src=\"".concat(rtn_val.img, "\">");
          if (rtn_val.sub_logo) {
            menu_html += "<img class=\"chain-logo\" src=\"".concat(rtn_val.sub_logo, "\">");
          }
          menu_html += "</div><div class=\"header-crypto-balance\">".concat(this.app.browser.formatDecimals(crypto_mod.returnBalance()), " ").concat(crypto_mod.ticker, "</div>");

          //price_usd
          /*if (crypto_mod.ticker !== 'SAITO') {
            let saito_numerator = Number(crypto_mod?.price_usd);
            let saito_denom = Number(ercMod?.price_usd);
             if (saito_numerator && saito_denom) {
              let multiplier = (0.92 * saito_numerator) / saito_denom;
              crypto_mod.exchange_rate = multiplier;
              value_in_saito = Number(crypto_mod.returnBalance) * multiplier;
               if (value_in_saito) {
                menu_html += `<div class="header-crypto-value">≈ ${this.app.browser.formatDecimals(value_in_saito)} SAITO</div>`;
              } else {
                menu_html += '<div></div>';
                //menu_html += `<div class="header-crypto-value">( 1 $${crypto_mod.ticker} ≈ ${this.app.browser.formatDecimals(multiplier)} $SAITO )</div>`;
              }
            } else {
              menu_html += '<div></div>';
            }
          } else {*/
          if (crypto_mod.pending_balance) {
            menu_html += "<div class=\"header-crypto-pending\">".concat(crypto_mod.pending_balance, " pending </div>");
          } else {
            menu_html += '<div></div>';
          }
          //}

          menu_html += "</div>";
          this.app.browser.addElementToSelector(options_html, '.wallet-select-crypto');
        }
        this.app.browser.replaceElementBySelector("<div class=\"saito-header-wallet-menu saito-menu-select-subtle\">".concat(menu_html, "</div>"), '.saito-header-wallet-menu');
      } catch (err) {
        console.error('Error rendering crypto selector: ' + err);
      }

      //Insert crypto balance
      try {
        if (preferred_crypto.isActivated()) {
          var balance_as_string = '';
          var b_elm = document.querySelector('.balance-amount');
          if (preferred_crypto !== null && preferred_crypto !== void 0 && preferred_crypto.pending_balance) {
            b_elm.classList.add('pending');
            balance_as_string = preferred_crypto.pending_balance;
          } else {
            b_elm.classList.remove('pending');
            balance_as_string = preferred_crypto.returnBalance();
          }
          b_elm.innerHTML = this.app.browser.returnBalanceHTML(balance_as_string);
          if (Date.now() - preferred_crypto.history_update_ts > 30000 && !this.checking_history) {
            this.checking_history = true;
            console.log('Checking preferred crypto history for new transactions');
            preferred_crypto.checkHistory(function () {
              delete _this7.checking_history;
            });
          }
        }
      } catch (err) {
        console.error('Error rendering crypto balance: ' + err);
      }

      // Attach Crypto events....
      Array.from(document.querySelectorAll('.saito-crypto-details')).forEach(function (c) {
        c.onclick = function (e) {
          _this7.app.connection.emit('saito-crypto-details-render-request', e.currentTarget.dataset.ticker);
        };
      });
      if (document.querySelector('.balance-amount')) {
        document.querySelector('.balance-amount').onclick = function (e) {
          _this7.app.connection.emit('saito-crypto-details-render-request', preferred_crypto.ticker);
        };
      }
    }
  }, {
    key: "initiateBalanceCheck",
    value: function initiateBalanceCheck() {
      var _this8 = this;
      var intervalTime = 2000;
      var preferred_crypto = this.app.wallet.returnPreferredCrypto();
      var _executeBalanceCheck = /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
          return _regenerator().w(function (_context7) {
            while (1) switch (_context7.n) {
              case 0:
                if (!(document.querySelector('.saito-header-backdrop.menu-visible') == null)) {
                  _context7.n = 1;
                  break;
                }
                _this8.clearBalanceCheck();
                console.log("Stopped checking ".concat(preferred_crypto.ticker, " balance"));
                return _context7.a(2);
              case 1:
                _context7.n = 2;
                return preferred_crypto.checkBalanceUpdate();
              case 2:
                //loop on time out
                _this8.balance_check_interval = setTimeout(_executeBalanceCheck, intervalTime);

                //double wait on each loop
                intervalTime *= 2;
              case 3:
                return _context7.a(2);
            }
          }, _callee7);
        }));
        return function executeBalanceCheck() {
          return _ref5.apply(this, arguments);
        };
      }();
      if (preferred_crypto.address) {
        _executeBalanceCheck(); // Start the loop
      }
    }
  }, {
    key: "clearBalanceCheck",
    value: function clearBalanceCheck() {
      clearTimeout(this.balance_check_interval);
    }
  }, {
    key: "clearPendingDepositsCheck",
    value: function clearPendingDepositsCheck() {
      clearInterval(this.deposit_check_interval);
    }
  }, {
    key: "initiatePendingDepositsCheck",
    value: function initiatePendingDepositsCheck() {
      var _this9 = this;
      var this_self = this;
      var intervalTime = 5000; // Start with 5 seconds
      var preferred_crypto = this_self.app.wallet.returnPreferredCrypto();
      var confirmations = preferred_crypto.confirmations;
      var _checkDeposits = /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
          return _regenerator().w(function (_context8) {
            while (1) switch (_context8.n) {
              case 0:
                if (!(document.querySelector('.saito-header-backdrop.menu-visible') == null)) {
                  _context8.n = 1;
                  break;
                }
                _this9.clearPendingDepositsCheck();
                console.log("Stopped checking ".concat(preferred_crypto.ticker, " deposit"));
                return _context8.a(2);
              case 1:
                console.log('check pending deposits');
                _context8.n = 2;
                return preferred_crypto.fetchPendingDeposits(function (res) {
                  if (res.length > 0) {
                    var pending_transfer = res[res.length - 1];
                    console.log('pending_transfer: ', pending_transfer);
                    var amount = Number(pending_transfer.amount);
                    console.log("".concat(amount, " ").concat(preferred_crypto.ticker, " deposit pending \n                    (").concat(pending_transfer.confirmations, "/").concat(confirmations, ")"));
                    if (amount > 0) {
                      this_self.updateHeaderMessage("".concat(amount, " ").concat(preferred_crypto.ticker, " deposit pending \n                        (").concat(pending_transfer.confirmations, "/").concat(confirmations, ")"), true, function () {
                        this_self.app.connection.emit('saito-crypto-history-render-request', {});
                      });
                      this_self.deposit_pending = true;
                      if (this_self.show_msg) {
                        siteMessage("New ".concat(preferred_crypto.ticker, " deposit"), 3000);
                        this_self.show_msg = false;
                      }
                    } else {
                      this_self.show_msg = true;
                    }
                  } else {
                    if (this_self !== null && this_self !== void 0 && this_self.deposit_pending) {
                      this_self.deposit_pending = false;
                      //this_self.updateHeaderMessage();
                    }
                    if (this_self.can_update_header_msg) {
                      //this_self.updateHeaderMessage();
                      this_self.show_msg = true;
                    }
                  }
                });
              case 2:
                // Double the interval and schedule the next check
                intervalTime *= 2;
                _this9.deposit_check_interval = setTimeout(_checkDeposits, intervalTime);
              case 3:
                return _context8.a(2);
            }
          }, _callee8);
        }));
        return function checkDeposits() {
          return _ref6.apply(this, arguments);
        };
      }();
      console.log("Started checking ".concat(preferred_crypto.ticker, " deposit"));
      _checkDeposits();
    }
  }]);
}(UIModTemplate);
module.exports = SaitoHeader;